import { Component, OnDestroy, OnInit } from '@angular/core';
import {
  ApplicationService,
  OpenTabData,
  DocumentTypeEnum,
  AuthenticationService,
  OrdersComponent,
} from 'beyond-util';

import { Subscription } from 'rxjs/Subscription';
import { PrihodiPoEmisijamaComponent } from '../izvestaji/prihodi-po-emisijama/prihodi-po-emisijama.component';
import { CenovniciComponent } from '../sifarnici/cenovnici/cenovnici.component';
import { CiljneGrupeComponent } from '../sifarnici/ciljne-grupe/ciljne-grupe.component';
import { VrstaZabraneComponent } from '../sifarnici/vrsta-zabrane/vrsta-zabrane.component';
import { SpotoviComponent } from '../sifarnici/spotovi/spotovi.component';
import { OdrzavanjeProgramaComponent } from '../sifarnici/odrzavanje-programa/odrzavanje-programa.component';
import { EmisijeComponent } from '../sifarnici/emisije/emisije.component';
import { PopustiUvecanjaComponent } from '../sifarnici/popusti-uvecanja/popusti-uvecanja.component';
import { PregledKupacaComponent } from '../sifarnici/pregled-kupaca/pregled-kupaca.component';
import { KorisniciComponent } from '../sifarnici/korisnici/korisnici.component';
import { UgovoriComponent } from '../sifarnici/ugovori/ugovori.component';
import { MediaPlanComponent } from '../media-plan/media-plan.component';
import { BackendService } from '../../services/backend.service';
import { KurseviComponent } from '../sifarnici/kursevi/kursevi.component';
import { BankeComponent } from '../sifarnici/banke/banke.component';
import { BrendoviComponent } from '../sifarnici/brendovi/brendovi.component';
import { NacinObracunaComponent } from '../sifarnici/nacin-obracuna/nacin-obracuna.component';
import { OdlukeComponent } from '../sifarnici/odluke/odluke.component';
import { NacinPlacanjaComponent } from '../sifarnici/nacin-placanja/nacin-placanja.component';
import { RezervacijeComponent } from '../rezervacije/rezervacije.component';
import { MontazaComponent } from '../montaza/montaza.component';
import { DnevniPlanEmitovanjaComponent } from '../izvestaji/dnevni-plan-emitovanja/dnevni-plan-emitovanja.component';
import { VerifikacijaComponent } from '../verifikacija/verifikacija.component';
import { PregledObracunaComponent } from '../pregled-obracuna/pregled-obracuna.component';
import { VrsteSpotaComponent } from '../sifarnici/vrste-spota/vrste-spota.component';
import { FakturisanjeComponent } from '../fakturisanje/fakturisanje.component';
import { TipoviKorekcijaComponent } from '../sifarnici/tipovi-korekcija/tipovi-korekcija.component';
import { VideoUputstvaComponent } from '../video-uputstva/video-uputstva.component';
import { KopijaVerifikacijeComponent } from '../kopija-verifikacije/kopija-verifikacije.component';
import { RealizacijaUgovoraComponent } from '../izvestaji/realizacija-ugovora/realizacija-ugovora.component';
import { PregledFakturaComponent } from '../pregled-faktura/pregled-faktura.component';
import { PregledSpecifikacijaComponent } from '../pregled-specifikacija/pregled-specifikacija.component';
import { AriannaComponent } from '../arianna/arianna.component';
import { AriannaGledanostEmisijeComponent } from '../arianna-gledanost-emisije/arianna-gledanost-emisije.component';
import { AriannaNekonsolidovaniComponent } from '../arianna-nekonsolidovani/arianna-nekonsolidovani.component';
import { IzvestajZaSokojComponent } from '../izvestaji/izvestaj-za-sokoj/izvestaj-za-sokoj.component';
import { MedijumiComponent } from '../sifarnici/medijumi/medijumi.component';
import { IzvestajZaOfpsComponent } from '../izvestaji/izvestaj-za-ofps/izvestaj-za-ofps.component';
import { GlinkMaska16Component } from '../izvestaji/glink-maska-16/glink-maska-16.component';
import { IzvestajRealizacijeComponent } from '../izvestaji/izvestaj-realizacije/izvestaj-realizacije.component';
import { IzvestajZaPgpIMuzickuProdukcijuComponent } from '../izvestaji/izvestaj-za-pgp-i-muzicku-produkciju/izvestaj-za-pgp-i-muzicku-produkciju.component';
import { PregledUgovoraZaObracunComponent } from '../pregled-ugovora-za-obracun/pregled-ugovora-za-obracun.component';
import { NepriznataEmitovanjaComponent } from '../nepriznata-emitovanja/nepriznata-emitovanja.component';
import { PregledAvansaComponent } from './../pregled-avansa/pregled-avansa.component';
import { PregledVerifikacijeComponent } from '../pregled-verifikacije/pregled-verifikacije.component';
import { IzvestajPrihodaPoEmisijamaComponent } from '../izvestaji/izvestaj-prihoda-po-emisijama/izvestaj-prihoda-po-emisijama.component';
import { ZeljenePozicijeComponent } from '../zeljene-pozicije/zeljene-pozicije.component';

@Component({
  selector: 'app-rts',
  templateUrl: './rts.component.html',
})
export class RtsComponent implements OnInit, OnDestroy {
  app = {
    group: 'rts',
    name: 'Rts',
  };
  activeTab = '';
  tabs = [];

  private _subscriptions: Array<Subscription> = [];

  constructor(
    private _backendService: BackendService,
    private applicationService: ApplicationService,
    private authenticationService: AuthenticationService
  ) {}

  ngOnInit() {
    this.registerDocumentTypes();
    this.registerHandlers();
    // this.loadMenu();
    this.fetchMenu();
    this.loadSecurity();
  }

  ngOnDestroy() {
    this.unsubscribeListeners();
  }

  registerHandlers() {
    this.unsubscribeListeners();

    this._subscriptions.push(
      this.applicationService.sidebarItemOpenEvent.subscribe((data: any) => {
        this.openTab(data);
      })
    );
  }

  private registerDocumentTypes(): void {
    // NOTE: Stringovi sa nazivima komponente ('Klijenti') moraju biti isti kao u settings json-u
    this.applicationService.registerViewComponent(
      'AdministracijaKorisnika',
      'ADMINISTRACIJAKORISNIKA',
      DocumentTypeEnum.Dokument,
      'MSKOR',
      'Administracija korisnika',
      KorisniciComponent
    );

    this.applicationService.registerViewComponent(
      'PopustiIUvecanja',
      'POPUSTIIUVECANJA',
      DocumentTypeEnum.Sifarnik,
      'M0_POPUSTIUVECANJA',
      'Popusti i uvećanja',
      PopustiUvecanjaComponent
    );

    // Sifarnici
    this.applicationService.registerViewComponent(
      'SifarnikCiljnihGrupa',
      'CILJNEGRUPE',
      DocumentTypeEnum.Sifarnik,
      'MSOP_CG',
      'Šifarnik ciljnih grupa',
      CiljneGrupeComponent
    );

    this.applicationService.registerViewComponent(
      'SifarnikNacinaObracuna',
      'NacinObracuna',
      DocumentTypeEnum.Sifarnik,
      'MSUGO_NO',
      'Šifarnik načina obračuna',
      NacinObracunaComponent
    );

    this.applicationService.registerViewComponent(
      'PregledCenovnika',
      'PREGLEDCENOVNIKA',
      DocumentTypeEnum.Sifarnik,
      'M6_SIF2',
      'Pregled cenovnika',
      CenovniciComponent
    );

    this.applicationService.registerViewComponent(
      'SifarnikOdluka',
      'ODLUKE',
      DocumentTypeEnum.Sifarnik,
      'MSCEN_ODL',
      'Šifarnik odluka',
      OdlukeComponent
    );

    this.applicationService.registerViewComponent(
      'VrstaZabrane',
      'VRSTAZABRANE',
      DocumentTypeEnum.Sifarnik,
      'M6_SIF5',
      'Vrste zabrane',
      VrstaZabraneComponent
    );

    this.applicationService.registerViewComponent(
      'PregledSpotova',
      'PREGLEDSPOTOVA',
      DocumentTypeEnum.Sifarnik,
      'MSSPOT',
      'Pregled spotova',
      SpotoviComponent
    );

    this.applicationService.registerViewComponent(
      'RealizacijaUgovora',
      'REALIZACIJAUGOVORA',
      DocumentTypeEnum.Izvestaj,
      'MSUGO_RUGO',
      'Realizacija ugovora',
      RealizacijaUgovoraComponent
    );

    this.applicationService.registerViewComponent(
      'PregledPrograma',
      'PREGLEDPROGRAMA',
      DocumentTypeEnum.Sifarnik,
      'MSPRO_PRO',
      'Pregled programa',
      OdrzavanjeProgramaComponent
    );

    this.applicationService.registerViewComponent(
      'PregledEmisija',
      'PregledEmisija',
      DocumentTypeEnum.Sifarnik,
      'M2_FOR2',
      'Pregled emisija',
      EmisijeComponent
    );

    this.applicationService.registerViewComponent(
      'PregledKlijenata',
      'PREGLEDLIJENATA',
      DocumentTypeEnum.Dokument,
      'MSKLI_KLI',
      'Pregled klijenata',
      PregledKupacaComponent
    );

    this.applicationService.registerViewComponent(
      'PregledUgovora',
      'PREGLEDUGOVORA',
      DocumentTypeEnum.Sifarnik,
      'MSUGO',
      'Pregled ugovora',
      UgovoriComponent
    );

    this.applicationService.registerViewComponent(
      'PregledKursa',
      'PREGLEDKURSA',
      DocumentTypeEnum.Sifarnik,
      'MSKURS_KURS',
      'Pregled kursa',
      KurseviComponent
    );

    this.applicationService.registerViewComponent(
      'MediaPlan',
      'MEDIAPLAN',
      DocumentTypeEnum.Sifarnik,
      'MSMP_MP',
      'Media Plan',
      MediaPlanComponent
    );

    this.applicationService.registerViewComponent(
      'PregledRezervacija',
      'PREGLEDREZERVACIJA',
      DocumentTypeEnum.Sifarnik,
      'MSMP_REZ',
      'Pregled rezervacija',
      RezervacijeComponent
    );

    this.applicationService.registerViewComponent(
      'PregledZeljenihPozicija',
      'PREGLEDZELJENIHPOZICIJA',
      DocumentTypeEnum.Sifarnik,
      'MSMP_POZ',
      'Pregled željenih pozicija',
      ZeljenePozicijeComponent
    );

    this.applicationService.registerViewComponent(
      'Montaza',
      'MONTAZA',
      DocumentTypeEnum.Sifarnik,
      'MSMON_MON',
      'Montaža',
      MontazaComponent
    );

    this.applicationService.registerViewComponent(
      'PregledBanaka',
      'PREGLEDBANAKA',
      DocumentTypeEnum.Sifarnik,
      'MSKURS_BNK',
      'Šifarnik banaka',
      BankeComponent
    );

    this.applicationService.registerViewComponent(
      'SifarnikBrendova',
      'SIFARNIKBRENDOVA',
      DocumentTypeEnum.Sifarnik,
      'MSSPO_BRE',
      'Šifarnik brendova',
      BrendoviComponent
    );

    this.applicationService.registerViewComponent(
      'SifarnikNacinaPlacanja',
      'SIFARNIKNACINAPLACANJA',
      DocumentTypeEnum.Sifarnik,
      'MSUGO_NP',
      'Šifarnik načina plaćanja',
      NacinPlacanjaComponent
    );

    this.applicationService.registerViewComponent(
      'VerifikacijaEmitovanja',
      'VERIFIKACIJAEMITOVANJA',
      DocumentTypeEnum.Sifarnik,
      'MSFAK_VER',
      'Verifikacija emitovanja',
      VerifikacijaComponent
    );

    this.applicationService.registerViewComponent(
      'VerifikacijaBezAsRunLoga',
      'VERIFIKACIJABEZASRUNLOGA',
      DocumentTypeEnum.Sifarnik,
      'MSFAK_VER2',
      'Verifikacija bez asRun loga',
      KopijaVerifikacijeComponent
    );

    this.applicationService.registerViewComponent(
      'PregledUgovoraZaObracun',
      'PREGLEDUGOVORAZAOBRACUN',
      DocumentTypeEnum.Sifarnik,
      'MSFAK_PO',
      'Pregled ugovora za obračun',
      PregledUgovoraZaObracunComponent
    );

    this.applicationService.registerViewComponent(
      'PregledObracuna',
      'PREGLEDOBRACUNA',
      DocumentTypeEnum.Sifarnik,
      'MSFAK_PO',
      'Pregled obračuna',
      PregledObracunaComponent
    );

    this.applicationService.registerViewComponent(
      'NepriznataEmitovanja',
      'NEPRIZNATAEMITOVANJA',
      DocumentTypeEnum.Sifarnik,
      'MSFAK_PO',
      'Pregled nepriznatih emitovanja',
      NepriznataEmitovanjaComponent
    );

    this.applicationService.registerViewComponent(
      'Predfakturisanje',
      'PREDFAKTURISANJE',
      DocumentTypeEnum.Sifarnik,
      'MSFAK_FAK',
      'Predfakturisanje',
      FakturisanjeComponent
    );

    this.applicationService.registerViewComponent(
      'PregledFaktura',
      'PREGLEDFAKTURA',
      DocumentTypeEnum.Sifarnik,
      'MSFAK_FAK',
      'Pregled faktura',
      PregledFakturaComponent
    );

    this.applicationService.registerViewComponent(
      'PregledSpecifikacija',
      'PREGLEDSPECIFIKACIJA',
      DocumentTypeEnum.Sifarnik,
      'MSFAK_FAK',
      'Pregled specifikacija',
      PregledSpecifikacijaComponent
    );

    this.applicationService.registerViewComponent(
      'Arianna',
      'ARIANNA',
      DocumentTypeEnum.Sifarnik,
      'MSARI_ARI',
      'Arianna',
      AriannaComponent
    );

    this.applicationService.registerViewComponent(
      'PregledAriannaPodataka',
      'PREGLEDARIANNAPODATAKA',
      DocumentTypeEnum.Sifarnik,
      'MSARI_ARI',
      'Pregled Arianna podataka',
      AriannaGledanostEmisijeComponent
    );

    this.applicationService.registerViewComponent(
      'Arianna - nekonsolidovani podaci',
      'Arianna - nekonsolidovani podaci',
      DocumentTypeEnum.Sifarnik,
      'MSARIA_ARI_N',
      'Arianna - nekonsolidovani podaci',
      AriannaNekonsolidovaniComponent
    );

    this.applicationService.registerViewComponent(
      'Pregled avansa',
      'Pregled avansa',
      DocumentTypeEnum.Sifarnik,
      'MSFAK_PO',
      'Pregled avansa',
      PregledAvansaComponent
    );

    // Reports
    this.applicationService.registerViewComponent(
      'izvestajPrihodaPoEmisijama',
      'PRIHODIPOEMISIJAMA',
      DocumentTypeEnum.Izvestaj,
      'M2_RPT1',
      'Izveštaj prihoda po emisijama',
      PrihodiPoEmisijamaComponent
    );

    // Reports
    this.applicationService.registerViewComponent(
      'IzvestajOPopunjenostiReklamnihBlokova',
      'IZVESTAJOPOPUNJENOSTIREKLAMNIHBLOKOVA',
      DocumentTypeEnum.Izvestaj,
      'M2_RPT2',
      'Izveštaj o popunjenosti reklamnih blokova',
      PrihodiPoEmisijamaComponent
    );

    this.applicationService.registerViewComponent(
      'DnevniPlanEmitovanja',
      'DNEVNIPLANEMITOVANJA',
      DocumentTypeEnum.Izvestaj,
      'MSIZV_DPE',
      'Dnevni plan emitovanja',
      DnevniPlanEmitovanjaComponent
    );

    this.applicationService.registerViewComponent(
      'IzvestajZaSokoj',
      'IZVESTAJZASOKOJ',
      DocumentTypeEnum.Izvestaj,
      'MSIZV_SOKOJ',
      'Izveštaj za SOKOJ',
      IzvestajZaSokojComponent
    );

    this.applicationService.registerViewComponent(
      'IzvestajZaOfps',
      'IZVESTAJZAOFPS',
      DocumentTypeEnum.Izvestaj,
      'MSIZV_OFPS',
      'Izveštaj za OFPS',
      IzvestajZaOfpsComponent
    );

    this.applicationService.registerViewComponent(
      'GlinkMaska16',
      'GLINKMASKA16',
      DocumentTypeEnum.Izvestaj,
      'MSRR_GLINK',
      'Pregled rezervisanih termina',
      GlinkMaska16Component
    );

    this.applicationService.registerViewComponent(
      'OsnovniIzvestajRealizacije',
      'OSNOVNIIZVESTAJREALIZACIJE',
      DocumentTypeEnum.Izvestaj,
      'MSRR_REAL',
      'Osnovni izveštaj realizacije',
      IzvestajRealizacijeComponent
    );

    this.applicationService.registerViewComponent(
      'SifarnikVrstaSpota',
      'SIFARNIKVRSTASPOTA',
      DocumentTypeEnum.Sifarnik,
      'MSSPO_VRSP',
      'Šifarnik vrsti spotova',
      VrsteSpotaComponent
    );

    this.applicationService.registerViewComponent(
      'SifarnikMedijuma',
      'SIFARNIKMEDIJUMA',
      DocumentTypeEnum.Sifarnik,
      'MSSPO_MED',
      'Šifarnik medijuma',
      MedijumiComponent
    );

    this.applicationService.registerViewComponent(
      'PregledTipovaKorekcije',
      'PREGLEDTIPOVAKOREKCIJE',
      DocumentTypeEnum.Sifarnik,
      'MSCEN_KOR',
      'Šifarnik tipova korekcija',
      TipoviKorekcijaComponent
    );

    this.applicationService.registerViewComponent(
      'videoUputstva',
      'VIDEOUPUTSTVA',
      DocumentTypeEnum.Izvestaj,
      'M2_RPT1',
      'Video uputstva',
      VideoUputstvaComponent
    );

    this.applicationService.registerViewComponent(
      'IzvestajZaBesplatnaEmitovanja',
      'IZVESTAJZABESPLATNAEMITOVANJA',
      DocumentTypeEnum.Izvestaj,
      'MSIZV_PGP',
      'Izveštaj za besplatna emitovanja',
      IzvestajZaPgpIMuzickuProdukcijuComponent
    );

    this.applicationService.registerViewComponent(
      'PregledVerifikacija',
      'PREGLEDVERIFIKACIJE',
      DocumentTypeEnum.Sifarnik,
      'MSFAK_VER',
      'Pregled verifikacija',
      PregledVerifikacijeComponent
    );

    this.applicationService.registerViewComponent(
      'IzvestajPrihodPoEmisiji',
      'IZVESTAJPRIHODPOEMISIJI',
      DocumentTypeEnum.Izvestaj,
      'MSIZV_PPE',
      'Izvestaj prihod po emisiji',
      IzvestajPrihodaPoEmisijamaComponent
    );
  }

  openTab(tab: any) {
    const tabName = tab.name;

    let pageToOpen = this.applicationService.findOpenTabDataByName(tabName);
    if (!pageToOpen) {
      // Automatically generated form, register it on-the-spot.
      pageToOpen = new OpenTabData(
        tabName,
        tabName,
        DocumentTypeEnum.Sifarnik,
        tab.code,
        tab.text,
        OrdersComponent
      );

      this.applicationService.registerViewComponent(
        tabName,
        '',
        DocumentTypeEnum.Sifarnik,
        tab.code,
        tab.text,
        OrdersComponent
      );
    }

    this.applicationService.closeTab(
      this.applicationService.findDocumentIdentityByName(tabName)
    );
    this.applicationService.openTab(pageToOpen);
  }

  setMenu(data: any) {
    this.applicationService.setMenu(data);
  }

  loadMenu() {
    const menu = {
      subitems: [
        {
          code: 'M0',
          name: 'OpstiModul',
          text: 'Opšti modul',
          subitems: [
            {
              code: 'M0_ADMINK',
              name: 'Korisnici',
              text: 'Administracija korisnika',
            },
            {
              code: 'M0_ADMINS',
              name: 'AdministracijaSifrarnika',
              text: 'Administracija šifrarnika',
            },
            {
              code: 'M0_POPUSTIUVECANJA',
              name: 'PopustiIUvecanja',
              text: 'Popusti i uvećanja',
            },
            {
              code: 'M0_KURSNALISTA',
              name: 'KursnaLista',
              text: 'Kursna lista',
            },
          ],
        },
        {
          code: 'M1',
          name: 'Ugovaranje',
          text: 'Ugovaranje',
          subitems: [
            {
              code: 'M2_FOR5',
              name: 'Ugovori',
              text: 'Pregled ugovora',
            },
          ],
        },
        {
          code: 'M2',
          name: 'Koordinacija',
          text: 'Koordinacija',
          subitems: [
            {
              code: 'M2_FOR1',
              name: 'OdrzavanjePrograma',
              text: 'Održavanje programa',
            },
            {
              code: 'M2_FOR2',
              name: 'Emisija',
              text: 'Emisije',
            },
            {
              code: 'M2_FOR3',
              name: 'PregledKupaca',
              text: 'Pregled kupaca',
            },
            {
              code: 'M2_FOR4',
              name: 'RasporedEmisija',
              text: 'Raspored emisija',
            },
            {
              code: 'M2_REPORTS',
              name: 'Reports',
              text: 'Izveštaji',
              subitems: [
                {
                  code: 'M2_RPT1',
                  name: 'izvestajPrihodaPoEmisijama',
                  text: 'Izveštaj prihoda po emisijama',
                },
              ],
            },
          ],
        },
        {
          code: 'M3',
          name: 'Realizacija',
          text: 'Realizacija',
        },
        {
          code: 'M4',
          name: 'Fakturisanje',
          text: 'Fakturisanje',
        },
        {
          code: 'M5',
          name: 'Podrska',
          text: 'Podrška',
        },
        {
          code: 'M6',
          name: 'Sifarnici',
          text: 'Šifarnici',
          subitems: [
            {
              code: 'M6_SIF1',
              name: 'CiljneGrupe',
              text: 'Ciljne grupe',
            },
            {
              code: 'M6_SIF2',
              name: 'Cenovnici', // documentName kad se registruje viewComponent-a
              text: 'Cenovnici',
            },
            {
              code: 'M6_SIF3',
              name: 'NacinEmitovanja',
              text: 'Način emitovanja',
            },
            {
              code: 'M6_SIF4',
              name: 'UcestalostEmitovanja',
              text: 'Učestalost emitovanja',
            },
            {
              code: 'M6_SIF5',
              name: 'VrstaZabrane',
              text: 'Vrsta zabrane',
            },
            {
              code: 'M6_SIF6',
              name: 'Spotovi',
              text: 'Spotovi',
            },
          ],
        },
        {
          code: 'M7',
          name: 'MediaPlanovi',
          text: 'Media Planovi',
          subitems: [
            {
              code: 'M7_SIF1',
              name: 'MediaPlan',
              text: 'Media plan',
            },
          ],
        },
        {
          code: 'M2_REPORTS',
          name: 'Reports',
          text: 'Izveštaji',
          subitems: [
            {
              code: 'M3_RPT3',
              name: 'dnevniPlanEmitovanja',
              text: 'Dnevni plan emitovanja',
            },
          ],
        },
        {
          code: 'M8_OBRACUNI',
          name: 'obracuni',
          text: 'Obracuni',
          subitems: [
            {
              code: 'M8_VERIFIKACIJA',
              name: 'verifikacija',
              text: 'Verifikacija',
            },
            {
              code: 'M9_PREGLED_OBRACUNA',
              name: 'pregledObracuna',
              text: 'Pregled obracuna',
            },
          ],
        },
      ],
    };
    this.setMenu(menu);
  }

  fetchMenu() {
    this._backendService.fetchMenu().subscribe((menu: any[]) => {
      menu['subitems'].push({
        code: 'M8_UPUTSTVA',
        name: 'Uputstva',
        text: 'Video uputstva',
        subitems: [
          {
            code: 'MSVUP_VUP',
            name: 'videoUputstva',
            text: 'Video uputstva',
          },
        ],
      });

      this.setMenu(menu);
    });
  }

  loadSecurity() {
    const params = {
      user: this.authenticationService.getUser().username,
      application: 'BM',
      organization: '01',
    };

    // this.backendService.loadSecurity(params).subscribe(data => {
    // }, error => {
    // });
  }

  unsubscribeListeners() {
    this._subscriptions.forEach((s: Subscription) => s.unsubscribe());
  }
}



// WEBPACK FOOTER //
// ./src/app/pages/rts/rts.component.ts